import React from 'react';

export default function LandingPage({ onNext }: { onNext: () => void }) {
  return (
    <div className="relative h-screen bg-[#1A1A1A] text-white flex flex-col justify-between">
      <div className="flex-1 overflow-y-auto flex flex-col items-center w-full max-w-sm mx-auto pb-4">
        <img
          src={require('../../assets/hanhwa/landing.png')}
          alt="Landing Banner"
          className="w-full rounded-lg mt-10"
        />

        <p className="text-center text-white font-['Pretendard'] text-[24px] font-semibold tracking-[-0.4px] my-10 shrink-0">
          앱 다운로드 후<br />
          모든 기능을 사용할 수 있어요.
        </p>
        <button
          onClick={() => {
            window.location.href = 'https://limh6.app.link/hanhwa';
          }}
          className="w-[90%] bg-[#28C8A8] text-black text-base font-semibold py-4 rounded-full shadow-md hover:brightness-110 transition-all shrink-0"
        >
          앱 다운로드
        </button>
      </div>

      <div className="sticky bottom-0 w-full bg-[#1A1A1A] pt-4 pb-6 shadow-[0_-4px_12px_rgba(0,0,0,0.3)]">
        <div className="w-full max-w-sm mx-auto px-4">
          <button
            onClick={onNext}
            className="block w-full bg-[#4F68FC] text-white text-base font-semibold py-4 rounded-full shadow-md hover:brightness-110 transition-all"
          >
            5초 감상 후 이지레스트 100%받기
          </button>
        </div>
      </div>
    </div>
  );
}
